import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=03d39940"
import script from "./contextMenu.vue?vue&type=script&lang=js"
export * from "./contextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d39940')) {
      api.createRecord('03d39940', component.options)
    } else {
      api.reload('03d39940', component.options)
    }
    module.hot.accept("./contextMenu.vue?vue&type=template&id=03d39940", function () {
      api.rerender('03d39940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/contextMenu/contextMenu.vue"
export default component.exports